import { useWeb3React } from '@web3-react/core'

export const useDomainName = () => {
  const { ENSName } = useWeb3React()

  return {
    name: ENSName || '',
  }
}
